import React from "react";
import Modal from "../../Modal/Modal";
import ReportConfigGridItem from "../../../../types/report/ReportConfigGridItem";

interface Props {
    onClose: () => void;
    configInfo: ReportConfigGridItem;
}

class ReportConfigInfoModal extends React.Component<Props, { isOpen: boolean }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: true
        };

        this.close = this.close.bind(this);
    }

    close(): void {
        this.setState({ isOpen: false });
        this.props.onClose();
    }

    render(): JSX.Element {
        return (
            <>
                <Modal state={{ isOpen: this.state.isOpen, title: 'Info', error: '' }} close={this.close} size='medium'>
                    <div className='display-flex width-100-percents'>
                        <label>Created By:</label><label className='margin-left-10px'>{this.props.configInfo.createdBy}</label>
                    </div>
                    <div className='display-flex width-100-percents'>
                        <label>Date Created:</label><label className='margin-left-10px'>{this.props.configInfo.createdTimestamp}</label>
                    </div>
                </Modal>
            </>
        );
    }
}

export default ReportConfigInfoModal;